import React from 'react';
import {Route, RouteComponentProps} from 'react-router-dom';
import {initGoogleAnalytics, sendGoogleAnalytics} from '../../utilities';
import {
  GoogleAnalyticsKey,
  GoogleAnalyticsEventType,
} from '../../utilities/constants';

class GoogleAnalytics extends React.Component<RouteComponentProps, never> {
  componentDidMount() {
    initGoogleAnalytics(GoogleAnalyticsKey);

    this.logPageChange(
      this.props.location.pathname,
      this.props.location.search
    );
  }

  componentDidUpdate({location: prevLocation}: RouteComponentProps) {
    const {
      location: {pathname, search},
    } = this.props;
    const isDifferentPathname = pathname !== prevLocation.pathname;
    const isDifferentSearch = search !== prevLocation.search;

    if (isDifferentPathname || isDifferentSearch) {
      this.logPageChange(pathname, search);
    }
  }

  logPageChange(pathname: string, search = '') {
    const page = pathname + search;
    const {location} = window;

    sendGoogleAnalytics({
      type: GoogleAnalyticsEventType.PageView,
      payload: `${location.origin}${page}`,
    });
  }

  render() {
    return null;
  }
}

const RouteTracker = () => <Route component={GoogleAnalytics} />;

export {GoogleAnalytics, RouteTracker};
